import { useFeatureFlagVariantKey } from 'posthog-js/react';

import { AUTO_LESSON_ANALYSIS_FEATURE_FLAG } from '../constants/autoAnalysis';

/**
 * Gates every Tutopiya AI auto lesson analysis control — the course-page
 * switch and both checkout switches. `test` shows them, `control` (and an
 * unresolved flag) hides them everywhere, and the checkout payloads drop the
 * `autoAnalysis` field entirely so a hidden switch can never opt a student in.
 */
export const useAutoLessonAnalysisEnabled = (): boolean =>
  useFeatureFlagVariantKey(AUTO_LESSON_ANALYSIS_FEATURE_FLAG) === 'test';

export default useAutoLessonAnalysisEnabled;
